import { object, string, array, boolean } from 'zod'
import type { NavigateByCategoriesProps } from 'src/components/department/types/navigate-by-categories'

export function useNavigateByCategories() {
  function validateProps(props: NavigateByCategoriesProps) {
    try {
      const schema = object({
        enableSession: boolean(),
        sessionTitle: object({
          text: string(),
        }),
        banner: object({
          enable: boolean(),
          image: object({
            mobile: string(),
            tablet: string(),
            desktop: string(),
          }),
          sessionButton: object({
            backgroundColor: string(),
            linkURL: string(),
            text: string(),
            textColor: string(),
          }),
          sessionTitle: object({
            text: string(),
            textColor: string(),
          }),
        }),
        categories: array(
          object({
            image: string(),
            name: string(),
            linkURL: string(),
          })
        ),
      })

      schema.parse(props)

      return true
    } catch (err) {
      console.warn('Invalid NavigateBySports data')

      return false
    }
  }

  return {
    validateProps,
  }
}
